//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList } from "@/mixins/index";
import addGameVideo from "./components/addGameVideo";
export default {
  name: "gameVideo",
  mixins: [loadMoreList],
  components: {
    addGameVideo: addGameVideo
  },
  data: function data() {
    return {
      pagingReqFn: "gameVideo",
      pagingReqValue: "list"
    };
  },
  activated: function activated() {
    this.getList();
  },
  methods: {
    del: function del(data) {
      var _this = this;

      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'delGameVideo',
        data: {
          id: [data.id]
        }
      }).then(function () {
        _this.getList();
      });
    }
  }
};